import { defineMessages } from 'react-intl';

export default defineMessages({
  className: {
    id: 'classtivity-scheduler-table.column.class-name',
    defaultMessage: 'Class Name',
  },
  startTime: {
    id: 'classtivity-scheduler-table.column.start-time',
    defaultMessage: 'Start Time',
  },
  duration: {
    id: 'classtivity-scheduler-table.column.duration',
    defaultMessage: 'Duration',
  },
  teacherName: {
    id: 'classtivity-scheduler-table.column.teacher',
    defaultMessage: 'Instructor',
  },
});
